export default __webpack_public_path__ + "static/media/nehadhandhania.2462c6e9.jpeg";